module.exports = __webpack_public_path__ + "img/unnamed.64ca32ba.jpg";